export const environment = {
    production: false,
    APIEndpoint: 'https://api.cheel-dev.gamithyatech.com',
    googleMapsApiKey: 'AIzaSyDoWngPtD5v5AZy-nXgeBOYL-NUvsHuqMU',
    keyCloakConfig:{
    issuer: 'https://auth.cheel-dev.gamithyatech.com/realms/gamithya',
    tokenEndpoint: 'https://auth.cheel-dev.gamithyatech.com/realms/gamithya/protocol/openid-connect/token',
    redirectUri: window.location.origin,
    clientId: 'webapp-client',
    responseType: 'code',
    scope: 'openid profile',
    showDebugInformation: true,
    oidc: true,
    requestAccessToken: true,
    sessionChecksEnabled: true,
    dummyClientSecret:'iduICGEtgIPY71aaqy9CBVtgCU0duDBC'
}
};